import { createContext, useContext, useState } from 'react'
import { createStore, useStore } from 'zustand'
import { type Setters } from '../../types'

export type RepositoryOverlayType = 'add-findings' | 'new-workflow' | 'manage-workflows' | 'repository-settings'

type RepositoryActionOverlaysValues = {
  currentOverlay?: RepositoryOverlayType
}

export type RepositoryActionOverlaysUIState = RepositoryActionOverlaysValues & Setters<RepositoryActionOverlaysValues>

const createRepositoryActionMenuStore = (initialState: Partial<RepositoryActionOverlaysValues> = {}) => {
  return createStore<RepositoryActionOverlaysUIState>(set => ({
    currentOverlay: initialState.currentOverlay,
    setCurrentOverlay: currentOverlay => set(() => ({ currentOverlay })),
  }))
}

const RepositoryActionMenuStoreContext = createContext<ReturnType<typeof createRepositoryActionMenuStore> | null>(null)

export const RepositoryActionMenuStoreProvider = ({
  children,
  initialState,
}: React.PropsWithChildren<{ initialState?: Partial<RepositoryActionOverlaysValues> }>) => {
  const [store] = useState(() => createRepositoryActionMenuStore(initialState))

  return <RepositoryActionMenuStoreContext value={store}>{children}</RepositoryActionMenuStoreContext>
}

export function useRepositoryActionMenuStore<U>(selector: (state: RepositoryActionOverlaysUIState) => U) {
  const store = useContext(RepositoryActionMenuStoreContext)

  if (!store) {
    throw new Error('useRepositoryActionMenuStore must be used within a RepositoryActionMenuStoreProvider')
  }

  return useStore(store, selector)
}
